export default __webpack_public_path__ + "static/media/VD2.30e3eac9.png";